<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title">{{ $t("survey.list.title") }}</h1>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('survey.list.name')}}</md-table-head>
          <md-table-head>{{$t('survey.list.questionText')}}</md-table-head>
          <md-table-head>{{$t('survey.list.edit')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="survey in templates" :key="survey.id">
          <md-table-cell>{{survey.name}}</md-table-cell>
          <md-table-cell>{{survey.questionText}}</md-table-cell>
          <md-table-cell>
              <md-button class="md-info" :to="`/survey/${survey.id}`">
              {{$t('survey.list.edit')}}

              </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      templates: state => state.SurveyModule.templates
    })
  },
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.$store.dispatch('getTemplates')
      .then(() => this.loading = false)
  }
}
</script>

<style>

</style>